module.exports = __webpack_public_path__ + "static/media/twitter-colored.0251d8ee.png";